/** @format */

import { IEnvironment } from './environment.interface';

export const baseEnvironment: Omit<IEnvironment, 'appName' | 'production' | 'env'> = {
  idoAuth: { url: 'https://edge-id.sesio.io', issuer: 'https://edge-id.sesio.io', clientId: 'engine-web' },
  region: 'eu-west-1',
  fullCalendarSchedulerLicenseKey: '0346024432-fcs-1791934062',
  noosGatewayUrl: 'https://endpoint.noos.sesio.io',
  supportUrl: 'https://support.sesio.io',
  mapboxAccessToken: 'pk.eyJ1IjoiZWhlcnZlIiwiYSI6ImNsOHlrZGFlcDA5NmUzdnBrOHR3bHdxY3gifQ.1tU0KXJak2Dh1yqA6sOpZQ',
};
